import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  position: relative;

  canvas {
    display: block;
    width: 100%;
    height: 100%;
  }
`
